import React from "react";
import { useSelector } from "react-redux";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import { edit } from "../Constant/Index";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";

function Pharmcypersonalinfo() {
	const userDetail = useSelector((state) => state?.Auth?.users);

	return (
		<>
			<Header />
			<PageHeader pagename="Pharmacy Profile" />
			<section className="main-sidebar  user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PharmacyProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="row">
									<div className="col-md-6">
										<div className="main-heading d-flex align-items-center gap-3 mb-3">
											<div className="edit-btn back">
												<div className="nav-anchor">
													<i className="fa-solid fa-arrow-left"></i>
												</div>
											</div>
											<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
												Personal Info
											</h5>
										</div>
									</div>
									<div className="col-md-6">
										<div
											style={{
												float: "right",
											}}
											className="main-heading d-flex align-items-center gap-3 mb-3"
										>
											<div className="edit-btn back">
												<Link to="/pharmacy-edit-info">
													<div className="nav-anchor">
														{/* <i className="fa-solid fa-arrow-left"></i> */}
														<img src={edit} alt="Edit" className="img-fluid" />
													</div>
												</Link>
											</div>
											<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
												Edit Personal Info
											</h5>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-lg-12">
										<div className="signup-wrapper edit-shifts-main">
											<form>
												<div className="row mb-5">
													<div className="col-lg-6 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																First Name
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.first_name}
															</p>
														</div>
													</div>

													<div className="col-lg-6 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																Last Name
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.last_name}
															</p>
														</div>
													</div>

													<div className="col-lg-6 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																Email
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.email}
															</p>
														</div>
													</div>

													<div className="col-lg-6 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																Phone number
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.phone}
															</p>
														</div>
													</div>

													<div className="col-lg-12  col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																Address
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.address}
															</p>
														</div>
													</div>
													<div className="col-lg-4 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																City
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.city}
															</p>
														</div>
													</div>
													<div className="col-lg-4 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																State
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.state}
															</p>
														</div>
													</div>
													<div className="col-lg-4 col-md-6 col-12">
														<div className="personal_info_time">
															<label className="main-heading level-7 mb-0 main-heading-font dark-color">
																Zip Code/Postal Code
															</label>
															<p className="level-9 mb-0 primary-medium-font extra-color-12">
																{userDetail?.zip_code}
															</p>
														</div>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Pharmcypersonalinfo;
